import axios, { AxiosResponse } from 'axios'

const requestClientSession = async () => {
  const res: AxiosResponse<{ clientSession: string }> = await axios.get(
    '/api/client-session',
  )

  return res?.data?.clientSession
}

export default requestClientSession
